import { Component, ViewChild } from '@angular/core';
import { NavbarStatus, NavigationItem, NavigationService } from 'src/app/core/navigation.service';
import { UtilsService } from 'src/app/core/utils.service';
import { COLOR_PRIMARY_CONTRAST_500, LOCAL_NAVBAR_STATUS_KEY } from 'src/app/shared/constants/operationals';
import { NavigationItemLabel } from 'src/app/shared/constants/translations';
import { HomeEvaluationCompaniesComponent } from '../home-evaluation-companies/home-evaluation-companies.component';
import { HomeSignatureCompaniesComponent } from '../home-signature-companies/home-signature-companies.component';
import { HomeAcceptanceCompaniesComponent } from '../home-acceptance-companies/home-acceptance-companies.component';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent {
  @ViewChild(HomeEvaluationCompaniesComponent) evaluation_companies?: HomeEvaluationCompaniesComponent;
  @ViewChild(HomeSignatureCompaniesComponent) signature_companies?: HomeSignatureCompaniesComponent;
  @ViewChild(HomeAcceptanceCompaniesComponent) acceptance_companies?: HomeAcceptanceCompaniesComponent;
  navbar_status: NavbarStatus;
  current_nav_item?: NavigationItem = this.navigation_service.navigation_set.nav_items.get(NavigationItemLabel.home);

  constructor(private utils_service: UtilsService, private navigation_service: NavigationService, private meta: Meta) {
    this.navbar_status = (localStorage.getItem(LOCAL_NAVBAR_STATUS_KEY) as NavbarStatus) || NavbarStatus.closed;
  }

  ngOnInit(): void {
    this.meta.updateTag({ content: COLOR_PRIMARY_CONTRAST_500 }, 'name=theme-color');
  }

  onNavbarStatusChange(navbar_status: NavbarStatus): void {
    this.navbar_status = navbar_status;
    localStorage.setItem(LOCAL_NAVBAR_STATUS_KEY, navbar_status);
  }

  onCompaniesRefresh(): void {
    this.evaluation_companies?.onRefresh();
    this.signature_companies?.onRefresh();
    this.acceptance_companies?.onRefresh();
  }

  getNavbarClass(): { [key: string]: boolean | undefined } {
    return this.utils_service.getNavbarClass(this.navbar_status);
  }

  getToolbarWidthClass(): string {
    if (this.navbar_status == NavbarStatus.open) {
      return 'sp-toolbar__open-width';
    }
    return 'sp-toolbar__closed-width';
  }
}
